/* import __COLOCATED_TEMPLATE__ from './create-custom-setting-fields.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import { taskFor } from 'ember-concurrency-ts';

export interface Args {
  isComplete: boolean;
  isInstallationComplete: boolean;
  salesforceConfiguration?: SalesforceConfiguration;
}

export default class SalesforceCopilotCreateCustomSettingFields extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare intl: IntlService;
  @service declare notificationsService: $TSFixMe;

  private get salesforcePlatform() {
    return this.finStandaloneService.salesforcePlatform;
  }

  @action
  async createCopilotCustomSettingsFields() {
    try {
      await taskFor(
        this.salesforcePlatform.salesforceDataLoader.createCopilotCustomSettingsFieldsTask,
      ).perform();
      this.notificationsService.notifyConfirmation(
        this.intl.t(
          'standalone.deploy.salesforce.copilot.create-custom-settings-fields.successfully-created-description',
        ),
      );
    } catch (error) {
      this.notificationsService.notifyResponseError(error);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Copilot::CreateCustomSettingFields': typeof SalesforceCopilotCreateCustomSettingFields;
    'standalone/deploy/salesforce/copilot/create-custom-setting-fields': typeof SalesforceCopilotCreateCustomSettingFields;
  }
}
